import ButtonVertical from "../ButtonVertical";
import { HiOutlineExternalLink } from "react-icons/hi";

type Props = React.ComponentProps<typeof ButtonVertical>;

const ButtonVerticalGoOut = (props: Props) => {
  return (
    <ButtonVertical
      {...props}
      icon={props.icon || <HiOutlineExternalLink fontSize={16} />}
      variant={props.variant || "primary"}
    >
      {props.children || "開"}
    </ButtonVertical>
  );
};

export default ButtonVerticalGoOut;
